const getPercent = (userInfo) => {
    if (userInfo.contract_type === 2) {
        return 95;
    }
    return 97;
};

const roundToTwo = (num) => Math.round(num * 100) / 100;

const calculateTotal = (invoiceData) => {
    let all_goods_prices = 0;
    let all_goods_price_alter = 0;

    let service_price = invoiceData.additions_sum || 0;
    let delivery_price = invoiceData.delivery_sum || 0;

    invoiceData.places.forEach(place => {
        place.goods.forEach(good => {
            all_goods_prices += good.insurance * good.count;
            all_goods_price_alter += good.price * good.count;
        });
    });

    let insurance_procent = invoiceData.user_info.insurance_procent;
    let insurance_sum = 0;

    // New insurance logic for contract_type === 3
    if (invoiceData.user_info.contract_type === 3 && insurance_procent === 0) {
        const total_price = all_goods_prices;
        let rate = 0;
        if (total_price <= 50000) {
            rate = 0.008;
            insurance_sum = Math.max(50, total_price * rate);
        } else if (total_price <= 100000) {
            rate = 0.0075;
            insurance_sum = total_price * rate;
        } else if (total_price <= 150000) {
            rate = 0.007;
            insurance_sum = total_price * rate;
        } else if (total_price <= 300000) {
            rate = 0.006;
            insurance_sum = total_price * rate;
        } else if (total_price <= 500000) {
            rate = 0.0055;
            insurance_sum = total_price * rate;
        } else if (total_price <= 1000000) {
            rate = 0.005;
            insurance_sum = total_price * rate;
        } else {
            rate = 0.0045;
            insurance_sum = total_price * rate;
        }

        console.log("insurance_sum:", insurance_sum, total_price, rate)
    } else {
        insurance_sum = all_goods_prices * (insurance_procent / 10000);
    }

    console.log("insurance_sum:", insurance_sum)
    
    // "Сборный груз" tariff logic
    if (invoiceData.tariff?.name?.includes("Сборный груз")) {
        const total_price = all_goods_prices;
        let additional_insurance_sum = 0;
        if (total_price <= 50000) {
            additional_insurance_sum = Math.max(50, total_price * 0.003);
        } else if (total_price <= 3000000) {
            additional_insurance_sum = total_price * 0.002;
        } else {
            additional_insurance_sum = total_price * 0.0018;
        }
        insurance_sum += additional_insurance_sum;
    }

    const insurance_value = insurance_sum;

    let XAG = 0;
    let ADOPSBOR = 0;
    let XAG1;

    if (invoiceData.user_info.contract_type === 2) {
        XAG1 = (all_goods_price_alter / 100) * 5;
    } else {
        XAG1 = (all_goods_price_alter / 100) * 3;
    }

    let delivery_pay = 0;
    let contract_pay = 0;

    // Logic from 5_invoiceCalculation.jsx, simplified for payment_on_receipt = false
    const commission = invoiceData.commission || false;
    const delivery_pay_from_recipient = invoiceData.delivery_pay || false;

    if (!invoiceData.payment_on_receipt && commission && delivery_pay_from_recipient) {
        XAG = (((delivery_price + service_price) + (insurance_value)) / getPercent(invoiceData.user_info) * 100) - ((delivery_price + service_price) + (insurance_value * all_goods_prices));
        ADOPSBOR = invoiceData.hand_sum ? parseFloat(invoiceData.hand_sum) : XAG + delivery_price + service_price + (insurance_value * all_goods_prices);
        delivery_pay = ADOPSBOR;
        contract_pay = 0;
    } else if (!invoiceData.payment_on_receipt && commission && !delivery_pay_from_recipient) {
        XAG = (((delivery_price + service_price) + (insurance_value)) / getPercent(invoiceData.user_info) * 100) - ((delivery_price + service_price) + (insurance_value * all_goods_prices));
        ADOPSBOR = invoiceData.hand_sum ? parseFloat(invoiceData.hand_sum) : 0;
        delivery_pay = ADOPSBOR;
        contract_pay = delivery_price + service_price + (insurance_value);
    } else if (!invoiceData.payment_on_receipt && !commission && delivery_pay_from_recipient) {
        XAG = (((delivery_price + service_price) + (insurance_value)) / getPercent(invoiceData.user_info) * 100) - ((delivery_price + service_price) + (insurance_value * all_goods_prices));
        ADOPSBOR = invoiceData.hand_sum ? parseFloat(invoiceData.hand_sum) : delivery_price + service_price + (insurance_value * all_goods_prices);
        delivery_pay = ADOPSBOR;
        contract_pay = XAG;
    } else { // !payment_on_receipt && !commission && !delivery_pay
        XAG = (((delivery_price + service_price) + (insurance_value)) / getPercent(invoiceData.user_info) * 100) - ((delivery_price + service_price) + (insurance_value * all_goods_prices));
        ADOPSBOR = invoiceData.hand_sum ? parseFloat(invoiceData.hand_sum) : 0;
        delivery_pay = ADOPSBOR;
        contract_pay = delivery_price + service_price + (insurance_value);
    }

    return {
        delivery_pay_amount: roundToTwo(delivery_pay),
        contract_pay: roundToTwo(contract_pay),
        additional_sum: invoiceData.payment_on_receipt ? roundToTwo(ADOPSBOR) : 0,
    };
};

export default calculateTotal; 